class StickyAddToCart {
  getStickyHeaderOffset = () => {
    const stickyHeader = document.querySelector(".sticky-header");
    if (!stickyHeader) {
      return 0;
    }
    return stickyHeader.offsetHeight;
  };

  constructor() {
    this.createSticky();
  }

  createSticky() {
    const mobileButton = document.querySelector(
      ".product-details .product-form__submit"
    );
    const formButton = document.querySelector(
      ".product-form__buttons .product-form__submit"
    );
    const footerElement = document.querySelector(".footer");
    const stickyHeaderOffset = this.getStickyHeaderOffset();
    const mq = window.matchMedia("(max-width: 999px)");

    if (!mobileButton || !mq.matches) {
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.target === footerElement) {
            this._isFooterVisible = entry.intersectionRatio > 0;
          }
          if (entry.target === formButton) {
            const boundingRect = formButton.getBoundingClientRect();
            this.isformButtonPassed =
              entry.intersectionRatio === 0 &&
              boundingRect.top + boundingRect.height <= stickyHeaderOffset;
          }

          console.log("Is form button passed: ", this.isformButtonPassed);
          if (this.isformButtonPassed && !this._isFooterVisible) {
            mobileButton.classList.add("sticky");
          } else {
            mobileButton.classList.remove("sticky");
          }
          // if (entry.intersectionRatio > 0.5) {
          //   console.log('Started leaving the viewport: ', entry.intersectionRatio);
          //   console.log('sticky');
          //   console.log('complete');
          // } else if (entry.intersectionRatio < 0.5) {
          //   console.log('Started entering the viewport: ', entry.intersectionRatio);
          //   console.log('not sticky');
          //   mobileButton.classList.remove('sticky');
          // }
        }
      },
      { rootMargin: `-${stickyHeaderOffset}px 0px 0px 0px` }
    );
    observer.observe(formButton);
    observer.observe(footerElement);
  }
}

export default StickyAddToCart;
